import CalendarFallbackIcon from '@components/shared/CalendarFallbackIcon'
import { taskCalendarFallbackUsed } from '@components/shared/calendarFallback'

function normalizeLabels(task) {
  if (Array.isArray(task.labels)) return task.labels
  if (Array.isArray(task.label)) return task.label
  if (typeof task.labels === 'string') return task.labels.split(',').map((item) => item.trim()).filter(Boolean)
  if (typeof task.label === 'string') return task.label.split(',').map((item) => item.trim()).filter(Boolean)
  return []
}

function getDueDate(task) {
  return task.dueDate || task.deadlineDate || task.vencimento || task.calculatedDeadline || task.endDate || null
}

function formatDueDate(value, unit) {
  if (!value) return 'Não calculado'

  const dueDate = new Date(value)
  if (Number.isNaN(dueDate.getTime())) return value

  const includesTime = unit === 'Hours' || unit === 2
  return new Intl.DateTimeFormat('pt-BR', {
    dateStyle: 'short',
    ...(includesTime ? { timeStyle: 'short' } : {}),
    timeZone: 'UTC',
  }).format(dueDate)
}

export default function DeadlineTasksCard({ tasks = [], displayTasks = [], deadlines = [], hasHumanReview = false }) {
  const hasStructuredTasks = tasks.length > 0
  const hasDisplayTasks = displayTasks.length > 0

  return (
    <section className="rules-card deadline-result-section">
      <div className="rules-card-header">
        <div>
          <h3>{hasHumanReview ? 'Tarefas sugeridas para conferência' : 'Tarefas sugeridas'}</h3>
          <p>
            {hasHumanReview
              ? 'Itens apontados pelo motor apenas para conferência; não representam prazo aprovado.'
              : 'Atividades e prazos sugeridos pelo motor para conferência operacional.'}
          </p>
        </div>
      </div>

      <div className="rules-card-body">
        {hasStructuredTasks ? (
          <div className="deadline-task-list">
            {tasks.map((task, index) => {
              const labels = normalizeLabels(task)
              const reasons = Array.isArray(task.reasons) ? task.reasons : []
              const dueDate = getDueDate(task)

              return (
                <article className="deadline-task-item" key={`${task.title || 'task'}-${index}`}>
                  <div className="deadline-task-header">
                    <div>
                      <h4>{task.title || 'Tarefa sugerida'}</h4>
                      <span>{task.taskType || 'Tipo não informado'}</span>
                    </div>
                    {task.humanReviewRequired ? <span className="status-badge is-warning">Revisão</span> : null}
                  </div>

                  <dl className="deadline-task-grid">
                    <div>
                      <dt>Quantidade</dt>
                      <dd>{task.quantity ?? 'Não informada'}</dd>
                    </div>
                    <div>
                      <dt>Unidade</dt>
                      <dd>{task.unit || 'Não informada'}</dd>
                    </div>
                    <div>
                      <dt>Vencimento</dt>
                      <dd>{formatDueDate(dueDate, task.unit)}{dueDate && <CalendarFallbackIcon fallbackUsed={taskCalendarFallbackUsed(task, deadlines)} />}</dd>
                    </div>
                  </dl>

                  {labels.length ? (
                    <div className="deadline-chip-list" aria-label="Labels da tarefa">
                      {labels.map((label) => <span className="criteria-chip" key={label}>{label}</span>)}
                    </div>
                  ) : null}

                  {reasons.length ? (
                    <div className="deadline-task-reasons">
                      <strong>Motivo da tarefa</strong>
                      <ul>
                        {reasons.map((reason, reasonIndex) => <li key={`${reason}-${reasonIndex}`}>{reason}</li>)}
                      </ul>
                    </div>
                  ) : null}
                </article>
              )
            })}
          </div>
        ) : null}

        {!hasStructuredTasks && hasDisplayTasks ? (
          <ul className="deadline-result-list">
            {displayTasks.map((task, index) => <li key={`${task}-${index}`}>{task}</li>)}
          </ul>
        ) : null}

        {!hasStructuredTasks && !hasDisplayTasks ? <p>Nenhuma tarefa automática foi gerada.</p> : null}
      </div>
    </section>
  )
}
